import { CTSType } from "fond/types";

interface CtsTypeOption {
  value: CTSType;
  label: string;
}

export const CTS_TYPE_OPTIONS: CtsTypeOption[] = [
  { value: "SharedCost", label: "Shared cost" },
  { value: "AccCost", label: "Accumulated cost" },
  { value: "IndivCost", label: "Individual cost" },
];

export const getCtsTypeLabel = (ctsType: CTSType): string | undefined => CTS_TYPE_OPTIONS.find((option) => option.value === ctsType)?.label;
